import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowUp, ArrowDown, Trash2, Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { errMsg } from "@/lib/api";

export function OptionListEditor({ open, onClose, title, items, onSave, testid }) {
  const [list, setList] = useState([]);
  const [add, setAdd] = useState("");
  useEffect(() => { if (open) setList(items || []); }, [open, items]);
  const move = (i, d) => { const l = [...list]; [l[i], l[i + d]] = [l[i + d], l[i]]; setList(l); };
  const save = async () => {
    try { await onSave(list); toast.success("List saved"); onClose(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid={testid}>
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <p className="text-xs text-[var(--muted-ink)]">"Other — Enter Manually" is always shown last. Custom entries typed by users are never added here automatically.</p>
        <ul className="max-h-80 space-y-1 overflow-y-auto">
          {list.map((x, i) => (
            <li key={x} className="flex items-center gap-1 rounded-md border px-2 py-1.5 text-sm" data-testid={`${testid}-item-${i}`}>
              <span className="flex-1">{x}</span>
              <button disabled={i === 0} onClick={() => move(i, -1)} className="p-1 disabled:opacity-30"><ArrowUp size={13} /></button>
              <button disabled={i === list.length - 1} onClick={() => move(i, 1)} className="p-1 disabled:opacity-30"><ArrowDown size={13} /></button>
              <button onClick={() => setList(list.filter((y) => y !== x))} className="p-1 text-red-600" data-testid={`${testid}-remove-${i}`}><Trash2 size={13} /></button>
            </li>
          ))}
        </ul>
        <div className="flex gap-2">
          <input className="inp" value={add} placeholder="Add option" onChange={(e) => setAdd(e.target.value)} data-testid={`${testid}-add-input`} />
          <button className="btn btn-ghost" data-testid={`${testid}-add-btn`} onClick={() => { const v = add.trim(); if (v && !list.some((y) => y.toLowerCase() === v.toLowerCase())) setList([...list, v]); setAdd(""); }}><Plus size={14} /></button>
        </div>
        <div className="flex justify-end gap-2"><button className="btn btn-ghost" onClick={onClose}>Cancel</button><button className="btn btn-primary" onClick={save} data-testid={`${testid}-save`}>Save list</button></div>
      </DialogContent>
    </Dialog>
  );
}
